import { SecureMessageContainer } from '@app.styled';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCenter } from '@fmc-digital/securemessages';
import { selectLoan } from '@store/selectors/widgets.selectors';
import { useSelector } from 'react-redux';
import { Identifier } from '@types';
import { lastDigits } from '@utils/lastDigits';
import { useMediaQuery, useTheme } from '@mui/material';
import { withHeaderFooter } from '@components_v2/HOCs/withHeaderFooter/withHeaderFooter';
import { isEmpty } from 'lodash';

const MessageCenterContainer: React.FC = withHeaderFooter(() => {
    const pathName = useLocation().pathname;
    const [loanNumber, setLoanNumber] = useState('');
    const loanList = useSelector(selectLoan);
    console.log('loanList', loanList);
    const [addresses, setAddresses] = useState([]);
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.between('xs', 'md'));
    useEffect(() => {
        const result = pathName.substring(pathName.lastIndexOf('/') + 1);
        setLoanNumber(result);
    }, []);
    useEffect(() => {
        const updatedAddresses: any[] = [];
        loanList?.map(loan => {
            const { identifier, propertyAddress } = loan;
            console.log('propertyAddress', propertyAddress);
            const val = `${propertyAddress?.address1} (...${lastDigits(identifier, 4)})`;
            updatedAddresses.push({
                label: val,
                value: val,
                id: val
            });
        });
        setAddresses(updatedAddresses);
    }, [loanList]);
    if (isEmpty(addresses)) return null;
    return (
        <SecureMessageContainer style={{ backgroundColor: isMobileView ? '#FEFEFE' : '' }}>
            <div style={{ height: isMobileView ? '84%' : '100%' }}>
                <MessageCenter />
            </div>
        </SecureMessageContainer>
    );
}, {});

export default React.memo(MessageCenterContainer);
